<ng-container *ngIf="ready">
    <ng-container>
        <div class="butonera">
            <button class="ms-2" mat-stroked-button (click)="import()">Importar</button>
        </div>

        <app-table [columns]="headerTable" [dataSource]="dataSource" [hasButton]="false">
        </app-table>
    </ng-container>

    <ng-container *ngIf="empty">
        <div class="text-center">
            <img src="assets/icons/contacto.svg" class="invoiceImage">
            <p style="color: #9e9e9e">No hay ninguna contacto de administración</p>
        </div>
    </ng-container>

</ng-container>
<ng-container *ngIf="ready === false">
    <div class="container text-center">
        <div class="cf-dlg-loading"><div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div></div>
    </div>
</ng-container>